import { Controller } from '@hotwired/stimulus';
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-signer-icon",
      animation: 150,
      onEnd: this.reorder.bind(this),
    });
  }

  reorder(event) {
    const containers = this.containerTargets;
    containers.forEach((container, index) => {
      const order = index + 1;
      container.querySelector('.contract-order-input').value = order;
      container.querySelector('.contract-order').innerHTML = order;
    });
    // md-outlined-select web components lose their value when DOM-reparented.
    // Restore from associated hidden fields.
    this._restoreSelectValues();
  }

  _restoreSelectValues() {
    // HR signer workflow selects
    this.element.querySelectorAll('[data-signers-target="recruiterWorkflowHidden"]').forEach(hidden => {
      const container = hidden.closest('.signer-container') || hidden.closest('.form-group');
      if (!container) return;
      const select = container.querySelector('[data-signers-target="recruiterWorkflowSelect"]');
      if (select && hidden.value) {
        select.value = hidden.value;
      }
    });
    // Employee signer workflow selects
    this.element.querySelectorAll('.employee-workflow-hidden').forEach(hidden => {
      const select = hidden.parentElement && hidden.parentElement.querySelector('md-outlined-select');
      if (select && hidden.value) {
        select.value = hidden.value;
      }
    });
  }
}
